module.exports = __webpack_public_path__ + "static/media/28DGC11.62783f3d.jpg";